import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Protege rutas por autenticación y, opcionalmente, por rol.
 * @param {string[]} [allowedRoles] - Si se pasa, el usuario debe tener uno de estos roles.
 */
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, loading, user, role } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = role || user?.role;
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to="/exams" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
